const talent = {
  title: '达人广场',
  search_placeholder: '搜达人 / 昵称',
  market: '市场',
  category: '品类',
  category_placeholder: '请选择类目',
  category_selected: '已选',
  category_search: '搜索类目',
  all: '全部',
  market_vn: '越南',
  market_th: '泰国',
  market_id: '印尼',
  market_my: '马来西亚',
  market_ph: '菲律宾',
  market_sg: '新加坡',
  cat_beauty: '美妆',
  cat_home: '家居',
  cat_fashion: '时尚',
  cat_digital: '数码',
  cat_lifestyle: '生活方式',
  add_to_mine: '加入我的达人',
  select_required: '请先勾选达人',
  already_collected: '所选达人已收藏',
  batch_outreach: '批量建联',
  batch_invite: '批量邀约',
  my_talents: '我的达人',
  col_talent: '达人',
  followers: '粉丝',
  gmv30: '近30日GMV',
  email: '邮箱',
  status: '状态',
  status_pending: '待建联',
  status_replied: '已回复',
  status_cooperated: '已合作',
  status_blacklist: '黑名单',
  load_failed: '达人列表加载失败',
  category_load_failed: '品类加载失败',
  col_actions: '操作',
  has_email: '有邮箱',
  favorited: '已收藏',
  favorite: '收藏',
  collect_success: '已收藏',
  collect_failed: '收藏失败',
  missing_open_id: '缺少达人 ID，无法收藏',
  outreach: '建联',
  target_invite: '定向邀约',
  blacklist: '黑名单',
  detail_title: '达人详情',
  detail_load_failed: '达人详情加载失败',
  pps_score: '带货分',
  live_gmv: '直播 GMV',
  video_gmv: '短视频 GMV',
  gmv_range: 'GMV 区间',
  units_sold_range: '销量区间',
  avg_live_uv: '直播平均 UV',
  avg_video_views: '短视频平均播放',
  creator_level: '达人等级',
  audience: '粉丝画像',
  age_range: '主力年龄',
  major_gender: '主力性别',
  gender_male: '男',
  gender_female: '女',
  demographics: '画像原文',
  official_recommend: '官方推荐',
  fast_growing: '快增长',
  collaborated: '已合作',
  invited_90d: '近90天已邀约',
  creator_blocked: '已被拉黑',
  flat_fee: '支持固定费用',
  rising_star: '新星',
  privacy_creator: '隐私达人',
  original_creator: '原创达人',
  mcn: '绑定 MCN',
  created_at: '创建时间',
  updated_at: '更新时间',
  match_score: '匹配分',
  start_outreach: '发起建联',
  view_emails: '查看邮件往来',
  block: '拉黑',
  gmv7: '近7日GMV',
  coop_products: '合作商品',
  content_count: '内容数',
  email_yes: '有',
  email_no: '无',
  why_fit: '为什么适合你',
  why_fit_fallback: '{{name}} 与当前店铺品类匹配，粉丝集中在东南亚市场，可优先尝试邮件建联与定向邀约。',
  timeline: '合作时间线',
  no_record: '暂无记录',
  timeline_empty_desc: '发起建联后将展示互动时间线。',
  products_title: '带货商品',
  products_empty: '暂无带货数据',
  col_product: '商品',
  col_gmv: 'GMV',
  col_output: '产出'
};

export default talent;
